// extracted by mini-css-extract-plugin
module.exports = {"errorLogs":"EditorFilesMobileFooter_errorLogs__2jv_W"};